import React, { useContext, useEffect, useState, Fragment } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { FaChevronDown } from 'react-icons/fa';
import { HeaderModal } from '../../contexts';
import ChangePwd from '../../components/Modals/ChangePwd';
import SwitchAccounts from '../../components/Modals/SwitchAccounts';
// import { useNylas } from '@nylas/nylas-react';

const User = ( { user, logout } ) => {
    const { openModal, closeModal, setModal } = useContext( HeaderModal );
    const [ showAccountSwitch, setShowAccountSwitch ] = useState( false );
    const [ showEmailAuth, setShowEmailAuth ] = useState( false );
    // const { authWithRedirect, exchangeCodeFromUrlForToken } = useNylas();
    const [ token, setToken ] = useState();
  
    // const mug = ( headshot && headshot.length ) ? headshot : 'https://tf-crm-images.s3.amazonaws.com/System/TF_CRM_UserProfile.png';
    const mug = 'https://tf-crm-images.s3.amazonaws.com/System/TF_CRM_UserProfile.png';

    const handleModal = async ( type ) => {
        let show = false;

        switch( type ) {
            case 'pwd':
                show = true;
                setModal( <ChangePwd close={closeModal} /> )
                break;

            case 'switch':
                show = true;
                setModal( <SwitchAccounts close={closeModal} /> );
                break;

            case 'nylas':
                show = false;
                // authWithRedirect( { emailAddress: user.email, successRedirectUrl: "/oauth/exchange" } );
                break;

            default:
                console.log( 'Unknown modal type: ' + type );
        }

        if ( show ) {
            openModal();
        }
    }

    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length ) {
            setShowAccountSwitch( true );
        } else {
            setShowAccountSwitch( false );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        if ( user.email === 'brian@thirdfloor.ai' ) {
            setShowEmailAuth( true );
        } else {
            setShowEmailAuth( false );
        }
    }, [ user.email ] );

    // useEffect(() => {
    //     const params = new URLSearchParams(window.location.search);
    //     if ( params.has( "code" ) ) {
    //         exchangeCodeFromUrlForToken().then( ( t ) => {
    //             console.log( 'Token: ', t );
    //             setToken( t );
    //             // do something with the response
    //         } );
    //     }
    // }, [ exchangeCodeFromUrlForToken ] );

    return (
        <Container fluid>
            <Row className='align-items-center'>
                <Col className='p-0 text-end'>
                    <img src={mug} height="40" style={ { borderRadius: '15%' } } alt='User Headshot' />
                </Col>
                <Col xs='auto'>{user.firstname}</Col>
                <Col xs='auto' className='ps-0 tf-global-user'>
                    <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent'>
                        {
                            ( showAccountSwitch ) ? (
                                <Fragment>
                                    <Dropdown.Item onClick={ () => handleModal( 'switch' ) }>Switch Accounts</Dropdown.Item>
                                    <Dropdown.Divider />
                                </Fragment>
                            ) : (
                                null
                            )
                        }
                        {
                            ( showEmailAuth ) ? (
                                <Fragment>
                                    {/* <Dropdown.Item onClick={ () => handleModal( 'nylas' ) }>Connect Your Email</Dropdown.Item>
                                    <Dropdown.Item>Token: {token}</Dropdown.Item>
                                    <Dropdown.Divider /> */}
                                </Fragment>
                            ) : (
                                null
                            )
                        }
                        <Dropdown.Item onClick={ () => handleModal( 'pwd' ) }>Change Password</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={ () => logout() }>Logout</Dropdown.Item>
                    </DropdownButton>
                </Col>
            </Row>
        </Container>
    )
}


const mapProps = ( state ) =>( {
    user: state.user
    // headshot: state.user.headshot,
    // aid: state.user.aid
} );

const mapDispatch = ( dispatch ) => ( {
    logout: dispatch.user.logout,
} );

export default connect( mapProps, mapDispatch )( User );